import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import InitializedAuth from "./auth/InitializedAuth";
import AuthProvider from "./auth/AuthProvider";
import RouterWrapper from "./RouterWrapper";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function App() {
  return (
    <div style={{ overflowX: "hidden", width: "100%", maxWidth: "100vw" }}>
      <AuthProvider>
        <Provider store={store}>
          <BrowserRouter>
            <InitializedAuth />
            <RouterWrapper />
            <ToastContainer
              position="bottom-center"
              autoClose={2000}
              hideProgressBar
              closeOnClick={false}
              pauseOnHover={false}
            />
          </BrowserRouter>
        </Provider>
      </AuthProvider>
    </div>
    
  );
}
export default App;